var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "col-12" }, [
    _c("div", { staticClass: "row d-flex justify-content-between mb-0" }, [
      _c("div", { staticClass: "tag-badge" }, [
        _c("span", { staticClass: "dot text-center pl-1" }, [
          _c("i", {
            staticClass: "orange-icon orange-icon-badge-align",
            class: _vm.page.icon
          })
        ]),
        _c("span", { staticClass: "tag-badge-title py-1 pl-2" }, [
          _vm._v(_vm._s(_vm.page.title))
        ])
      ])
    ]),
    _vm.hasRoute
      ? _c("div", { staticClass: "row mt-2 controls-wrap" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "div",
              { staticClass: "nav-text mt-1" },
              [
                _vm._v(" Usted se encuentra aquí: "),
                _vm._l(_vm.page.routes, function(item, index) {
                  return _c("span", { key: index }, [
                    _c(
                      "a",
                      {
                        staticClass: "nav-text-link",
                        class: {
                          "nav-text-current":
                            index === _vm.page.routes.length - 1
                        }
                      },
                      [
                        _vm._v(" " + _vm._s(item) + " "),
                        !(index === _vm.page.routes.length - 1)
                          ? _c("span", [_vm._v("/")])
                          : _vm._e()
                      ]
                    )
                  ])
                })
              ],
              2
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }